import { Interaction } from "@/service/Model";
import { scaleRange } from "@/utils/transform";

export type Point = {
  x: number;
  y: number;
};

export const centerPoint: Point = { x: 335, y: 331 };
export const totalWidth = centerPoint.x * 2;

export const bucketsCount = 7;
export const bucketWidth = totalWidth / bucketsCount;
export const spaceBetweenBucketsOffset = 30;
export const percentageGutter = 65;

export const maxAnswer = centerPoint.x;
export const minAnswer = -maxAnswer;

export const buckets: number[] = [];

for (let i = 0; i < bucketsCount; i++) {
  // Calculate center x-point of each bucket
  const bucket = bucketWidth * i + bucketWidth / 2;
  buckets.push(bucket);
}

export type Result = {
  amount: number;
  percent: number;
  bucket: number;
  opacity: number;
  size: number;
};

export function getAnswerBucket(answer: number): number {
  if (answer >= maxAnswer) {
    return bucketsCount - 1;
  } else if (answer < minAnswer) {
    return 0;
  }
  return Math.floor(scaleRange(answer, minAnswer, maxAnswer, 0, bucketsCount));
}

export const maxPercent = 0;
export const minPercent = 100;
export const maxAlpha = 1;
export const minAlpha = 0.5;
export const maxSize = 250;
export const minSize = (mobile?: boolean): number => (mobile ? 80 : 60);

export function isEnded(interaction: Interaction): boolean {
  return !!interaction.endDate && interaction.endDate < new Date().getTime();
}

export function debounce(callback: () => void, wait: number): () => void {
  let h: number;
  return () => {
    clearTimeout(h);
    h = window.setTimeout(() => callback(), wait);
  };
}
